var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SearchBar',{ref:"MinimalSearchBar",attrs:{"active":true,"minimalSearch":true},on:{"user-is-searchin":_vm.userIsTypingSomething}})
}
var staticRenderFns = []

export { render, staticRenderFns }